/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * The number of days that logs are retained for this project.
 * @export
 * @interface ProjectEntitlementsLogRetentionDays
 */
export interface ProjectEntitlementsLogRetentionDays {
    /**
     * The log retention period for this project, in days.
     * @type {number}
     * @memberof ProjectEntitlementsLogRetentionDays
     */
    value: number;
}

/**
 * Check if a given object implements the ProjectEntitlementsLogRetentionDays interface.
 */
export function instanceOfProjectEntitlementsLogRetentionDays(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function ProjectEntitlementsLogRetentionDaysFromJSON(json: any): ProjectEntitlementsLogRetentionDays {
    return ProjectEntitlementsLogRetentionDaysFromJSONTyped(json, false);
}

export function ProjectEntitlementsLogRetentionDaysFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectEntitlementsLogRetentionDays {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function ProjectEntitlementsLogRetentionDaysToJSON(value?: ProjectEntitlementsLogRetentionDays | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

